import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  Grid,
  IconButton,
  Input,
  Select,
  SimpleGrid,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Badge,
  Divider,
  HStack,
  InputGroup,
  InputLeftElement,
  Tooltip,
  VStack,
} from '@chakra-ui/react';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import BackButton from 'components/BackButton';
import ResetPasswordModal from 'components/reset-password';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { getUserData } from 'utils';
import ErrorMessage from 'components/error-message';
import AssignLocationModalV2 from '../components/AssignLocationModalV2';
import { MdDelete } from 'react-icons/md';
import DeleteModal from 'components/deleteModal/DeleteModal';
import { toProperCase } from 'utils/formatting';
import moment from 'moment';
import { useUserProfile } from 'contexts/UserProfileContext';
import {} from '@chakra-ui/react';
import { SearchIcon, RepeatIcon } from '@chakra-ui/icons';
import { fetchLoginLogsByUserId } from 'config/api/loginLogs';
import { convertToCST } from 'utils/formatting';

const getTagBadge = (tag) => {
  const t = (tag || '').toUpperCase();
  if (t.includes('SUCCESS')) return { scheme: 'green', label: tag };
  if (t.includes('FAIL') || t.includes('ERROR'))
    return { scheme: 'red', label: tag };
  if (t.includes('2FA')) return { scheme: 'blue', label: tag };
  return { scheme: 'gray', label: tag || 'N/A' };
};

const getStatusBadge = (code) => {
  const c = Number(code || 0);
  if (c >= 200 && c < 300) return { scheme: 'green', label: c };
  if (c >= 300 && c < 400) return { scheme: 'blue', label: c };
  if (c >= 400 && c < 500) return { scheme: 'orange', label: c };
  if (c >= 500) return { scheme: 'red', label: c };
  return { scheme: 'gray', label: code ?? '—' };
};

export default function TeamDetails(props) {
  const navigate = useNavigate();
  const location = useLocation();
  // Extract id from pathname
  const pathParts = location.pathname.split('/');
  const id = pathParts[pathParts.length - 1]; // const { id } = location.state;

  const { ...rest } = props;
  const userData = getUserData();
  const user_id = userData?.id ?? null;
  const clinic_id = userData?.clinic_id ?? null;
  const { getUser, user } = useUserProfile();
  const [memberUser, setMemberUser] = useState(null);

  console.log('🚀 ~ TeamDetails ~ is_form_access:', user?.is_form_access);
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'gray.400';
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const headerBg = useColorModeValue('white', 'gray.900');
  const skeletonBg = useColorModeValue('gray.100', 'whiteAlpha.100');

  const [loading, setLoading] = useState(true);
  const [isSaving, setISaving] = useState(false);
  const [isSavingDashboard, setIsSavingDashboard] = useState(false);
  const [teamMember, setTeamMember] = useState({});
  const [staffLocations, setStaffLocations] = useState([]);
  const [staffLocationRows, setStaffLocationRows] = useState([]);
  // const [currentRole, setCurrentRole] = useState('');
  const [currentRoleId, setCurrentRoleId] = useState('');
  const [currentRoleName, setCurrentRoleName] = useState('');
  const [currentStatus, setCurrentStatus] = useState('');
  const [isAssignOpen, setIsAssignOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);

  // 🟢 Form Access Permission State
  const [isFormAccess, setIsFormAccess] = useState(false);
  const [isSavingFormAccess, setIsSavingFormAccess] = useState(false);

  // ✅ Login Logs state
  const [loginLogs, setLoginLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [logsError, setLogsError] = useState('');

  // filters
  const [logSearch, setLogSearch] = useState('');
  const [logTag, setLogTag] = useState('ALL');
  const [logStatus, setLogStatus] = useState('ALL');

  // ADD THESE NEW STATES near other useState declarations
  const [enable30dTokenExpiry, setEnable30dTokenExpiry] = useState(false);
  const [isSavingTokenExpiry, setIsSavingTokenExpiry] = useState(false);
  const [effectiveTokenExpiryDays, setEffectiveTokenExpiryDays] =
    useState(null);

  useEffect(() => {
    if (user) {
      setIsFormAccess(user.is_form_access || false);
    }
  }, [user]);

  const handleAssignClick = () => {
    setIsAssignOpen(true);
  };

  const handleCloseDeleteModal = () => {
    if (isDeleting) return; // prevent closing while deleting
    setDeleteModalOpen(false);
    setSelectedItem(null);
  };

  // const handleDeleteItem = async () => {
  //   if (!selectedItem || !teamMember?.user_id) return;

  //   setIsDeleting(true);
  //   try {
  //     // Replace with the correct endpoint if different
  //     await createAPIEndPoint(
  //       `staff_locations/delete/${teamMember.user_id}/`,
  //     ).delete(selectedItem.location_id);

  //     await fetchStaffLocations(); // refresh the assigned locations table
  //     setDeleteModalOpen(false); // close modal
  //     setSelectedItem(null);
  //     toast.success('Location removed from staff');
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Failed to remove location');
  //   } finally {
  //     setIsDeleting(false);
  //   }
  // };

  const handleDeleteItem = async () => {
    if (!selectedItem || !teamMember?.user_id) return;

    // Capture values BEFORE clearing state
    const locName = selectedItem.location_name || 'Location';
    const memberName =
      `${teamMember?.first_name || ''} ${teamMember?.last_name || ''}`.trim() ||
      'staff';

    setIsDeleting(true);
    try {
      await createAPIEndPoint(
        `staff_locations/delete/${teamMember.user_id}/`,
      ).delete(selectedItem.location_id);

      // Show toast with the location name
      toast.success(`${locName} removed from ${memberName}`);

      // Refresh and then clear state/close
      await fetchStaffLocations();
      setDeleteModalOpen(false);
      setSelectedItem(null);
    } catch (err) {
      toast.error(err?.response?.data?.error || `Failed to remove ${locName}`);
    } finally {
      setIsDeleting(false);
    }
  };

  // 👉 add this function
  const fetchMemberUser = async (uid) => {
    if (!uid) return;
    try {
      const res = await createAPIEndPoint('user/').fetchById(`${uid}`);
      setMemberUser(res.data || {});
      // set is_form_access from the actual user API
      setIsFormAccess(Boolean(res.data?.is_form_access));
    } catch (err) {
      console.error('Error fetching member user:', err);
    }
  };

  useEffect(() => {
    if (teamMember?.user_id) {
      fetchMemberUser(teamMember.user_id);
    }
  }, [teamMember?.user_id]);

  const getTeam = async () => {
    try {
      getUser();
      setLoading(true);
      const response = await createAPIEndPoint('clinic_team').fetchById(
        `/${id}`,
      );
      const member = response.data.team_member;

      setTeamMember(member);
      // setCurrentRole(member.clinic_role || '');
      setCurrentRoleId(member.clinic_role_id || '');
      setCurrentRoleName((member.clinic_role || '').toLowerCase());
      setCurrentStatus(member.userStatus || '');
      setSelectedDashboards(member.dashboard_ids || []);
      setIsFormAccess(member.is_form_access || false);

      setLoading(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Error fetching team details',
      );
      if (error?.response?.data?.error.includes('Bearer token')) {
        logoutUser(navigate);
      }
      setLoading(false);
    }
  };

  const fetchLoginLogs = async (uid) => {
    if (!uid) return;
    setLogsLoading(true);
    setLogsError('');
    try {
      const logs = await fetchLoginLogsByUserId(uid);
      setLoginLogs(Array.isArray(logs) ? logs : []);
    } catch (err) {
      setLoginLogs([]);
      setLogsError(err?.response?.data?.error || 'Failed to fetch login logs');
    } finally {
      setLogsLoading(false);
    }
  };

  useEffect(() => {
    if (teamMember?.user_id) {
      fetchLoginLogs(teamMember.user_id);
    }
  }, [teamMember?.user_id]);

  const availableTags = React.useMemo(() => {
    const set = new Set(loginLogs.map((l) => l.tag).filter(Boolean));
    return ['ALL', ...Array.from(set)];
  }, [loginLogs]);

  const availableStatuses = React.useMemo(() => {
    const set = new Set(
      loginLogs
        .map((l) => l.status_code)
        .filter((v) => v !== null && v !== undefined),
    );
    const list = Array.from(set).sort((a, b) => Number(a) - Number(b));
    return ['ALL', ...list];
  }, [loginLogs]);

  const filteredLogs = React.useMemo(() => {
    const q = (logSearch || '').trim().toLowerCase();

    return (
      loginLogs
        .filter((l) =>
          logTag === 'ALL' ? true : String(l.tag) === String(logTag),
        )
        .filter((l) =>
          logStatus === 'ALL'
            ? true
            : String(l.status_code) === String(logStatus),
        )
        .filter((l) => {
          if (!q) return true;
          const blob = [
            l.message,
            l.endpoint,
            l.ip_address,
            l.system_name,
            l.tag,
            l.status_code,
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

          return blob.includes(q);
        })
        // latest first
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    );
  }, [loginLogs, logSearch, logTag, logStatus]);

  const staffLocationColumnHelper = createColumnHelper();

  const staffLocationColumns = [
    staffLocationColumnHelper.accessor((row, index) => index + 1, {
      id: '#',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          #
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue()}
        </Text>
      ),
    }),
    staffLocationColumnHelper.accessor('location_name', {
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          Location Name
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue()}
        </Text>
      ),
    }),
    // Action column (button to remove/unassign)
    staffLocationColumnHelper.display({
      id: 'action',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          ACTION
        </Text>
      ),
      cell: (info) => {
        const openDelete = () => {
          setSelectedItem(info.row.original); // { location_id, location_name, clinic_id }
          setDeleteModalOpen(true);
        };
        return (
          <IconButton
            aria-label="Delete"
            icon={<MdDelete style={{ marginLeft: '-1px' }} />}
            colorScheme="red"
            size="sm"
            onClick={openDelete}
          />
        );
      },
    }),
  ];

  const staffLocationTable = useReactTable({
    data: staffLocationRows,
    columns: staffLocationColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  const fetchStaffLocations = async () => {
    try {
      const response = await createAPIEndPoint(
        `clinic_team/staff/locations/${teamMember.user_id}`,
      ).fetchAll();
      const locations = response.data.staff_locations || [];
      setStaffLocations(locations);
      setStaffLocationRows(
        locations.map((l) => ({
          location_name: l.location_name,
          location_id: l.location_id,
          clinic_id: l.clinic_id,
        })),
      );
    } catch (error) {
      // toast.error('Error fetching staff assigned locations');
    }
  };

  // const fetchDashboards2 = async () => {
  //   try {
  //     const response = await createAPIEndPoint(`user_dashboards`).fetchById(
  //       `/38`,
  //     );
  //     console.log(' fetchDashboards2 ~ response:', response);
  //   } catch (err) {
  //     console.log('Error:', err);
  //   }
  // };

  // useEffect(() => {
  //   fetchDashboards2();
  // }, []);

  const updateTeam = async () => {
    try {
      setISaving(true);
      const payload = {
        userStatus: currentStatus,
        // clinic_role_id: currentRole,
        clinic_role_id: Number(currentRoleId),
        dashboard_ids: selectedDashboards,
      };
      const response = await createAPIEndPoint('clinic_team/').update(
        id,
        payload,
      );
      setTeamMember(response.data.team_member);
      const updated = response.data.team_member || {};
      setTeamMember(updated);
      setCurrentRoleId(updated.clinic_role_id ?? currentRoleId);
      setCurrentRoleName((updated.clinic_role || '').toLowerCase());
      toast.success('Updated successfully');
      setISaving(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Error updating team details',
      );
      setISaving(false);
    }
  };

  const updateDashboards = async () => {
    try {
      setIsSavingDashboard(true);
      const payload = {
        user_id: teamMember.user_id,
        dashboard_id: selectedDashboards,
      };
      const response =
        await createAPIEndPoint('user_dashboards').patchDashboard(payload);
      // setTeamMember(response.data.team_member);
      toast.success('dashboards updated successfully');
      setIsSavingDashboard(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Error updating team details',
      );
      setIsSavingDashboard(false);
    }
  };

  const [roles, setRoles] = useState([]);
  const [dashboards, setDashboards] = useState([]);
  const [selectedDashboards, setSelectedDashboards] = useState([]);

  const handleDashboardChange = (dashboardId) => {
    setSelectedDashboards(
      (prev) =>
        prev.includes(dashboardId)
          ? prev.filter((id) => id !== dashboardId) // Uncheck if already selected
          : [...prev, dashboardId], // Add if not selected
    );
  };
  const fetchDashboards = async () => {
    try {
      const response = await createAPIEndPoint('dashboard').fetchAll();
      console.log(' fetchDashboards ~ response:', response);
      const dashboards = response.data.dashboards || [];

      // Map locations to format name, city, and state
      const formattedLocations = dashboards.map((dashboard) => ({
        id: dashboard.id,
        name: `${dashboard.name}`, // Display name with city & state
      }));

      setDashboards(formattedLocations);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to fetch locations');
    }
  };

  useEffect(() => {
    const getRoles = async () => {
      try {
        const response = await createAPIEndPoint(
          `clinic_roles/get_all/${clinic_id}`,
        ).fetchAll();
        setRoles(response.data.roles);
      } catch (error) {
        toast.error(error?.response?.data?.error || 'Error fetching roles');
      }
    };

    getRoles();
  }, [id]);

  useEffect(() => {
    fetchDashboards();
    getTeam();
  }, [id]);

  useEffect(() => {
    if (currentRoleName === 'staff' && teamMember.user_id) {
      fetchStaffLocations();
    }
  }, [currentRoleName, teamMember.user_id]);

  const handleStatusChange = async () => {
    const newStatus = currentStatus === 'active' ? 'disable' : 'active';
    setCurrentStatus(newStatus);

    try {
      await createAPIEndPoint('clinic_team/').update(id, {
        userStatus: newStatus,
      });
      toast.success(
        `User ${newStatus === 'active' ? 'enabled' : 'inactive'} successfully`,
      );
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Error updating user status');
    }
  };

  // const handleRoleChange = (event) => {
  //   setCurrentRole(event.target.value);
  // };

  const handleQrReset = async () => {
    try {
      const payload = { user_id: teamMember.user_id };

      await createAPIEndPoint(`user/reset_mfa/${clinic_id}`).update(
        teamMember.user_id,
        payload,
      );

      toast.success('QR Authenticator has been reset successfully');
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Failed to reset QR Authenticator',
      );
    }
  };

  // ADD THIS NEW FUNCTION anywhere with other handlers

  const handleSaveTokenExpiry = async () => {
    try {
      setIsSavingTokenExpiry(true);

      const payload = {
        user_id: teamMember.user_id,
        enable_30d_token_expiry: enable30dTokenExpiry,
      };

      const response = await createAPIEndPoint(
        'user/token-expiry-toggle',
      ).update('', payload);
      // assumes same helper uses PUT for update()

      const days = response?.data?.effective_token_expiry_days ?? 14;

      setEffectiveTokenExpiryDays(days);

      toast.success(`Token expiry updated to ${days} days`);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Failed to update token expiry',
      );
    } finally {
      setIsSavingTokenExpiry(false);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  // --- Phone Number Logic --- //
  const [isSavingPhone, setIsSavingPhone] = useState(false);

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    const formatted = !match[2]
      ? match[1]
      : `(${match[1]}) ${match[2]}${match[3] ? `-${match[3]}` : ''}`;

    return formatted.length > 14 ? formatted.slice(0, 14) : formatted;
  };

  const handleSavePhone = async () => {
    if (!teamMember?.user_id) {
      toast.error('User ID missing');
      return;
    }

    const phone = teamMember.phone?.trim();
    if (!phone || !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) {
      toast.error('Please enter a valid phone number (XXX) XXX-XXXX');
      return;
    }

    try {
      setIsSavingPhone(true);
      await createAPIEndPoint('user/').update(teamMember.user_id, {
        phone: phone,
      });
      toast.success('Phone number updated successfully!');
    } catch (err) {
      toast.error(
        err?.response?.data?.message || 'Failed to update phone number',
      );
    } finally {
      setIsSavingPhone(false);
    }
  };

  const handleSaveFormAccess = async () => {
    try {
      setIsSavingFormAccess(true);
      const payload = { is_form_access: isFormAccess };

      // ✅ update the team member's user row
      await createAPIEndPoint('user/').update(teamMember?.user_id, payload);

      // refresh that member’s user object
      await fetchMemberUser(teamMember?.user_id);

      toast.success(
        `Form access ${isFormAccess ? 'enabled' : 'disabled'} successfully!`,
      );
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Failed to update form access',
      );
    } finally {
      setIsSavingFormAccess(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
        <BackButton />
        <Grid
          templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
          templateRows={{ base: 'repeat(2, 1fr)', lg: '1fr' }}
          gap={{ base: '20px', xl: '20px' }}
        >
          <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="8px"
              mb="24px"
            >
              General Information
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Name:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {teamMember.first_name && teamMember.last_name
                    ? `${toProperCase(teamMember.first_name)} ${toProperCase(
                        teamMember.last_name,
                      )}`
                    : 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Email:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {teamMember.email || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Role:
                </Text>
                <Text
                  color={textColorSecondary}
                  fontSize="md"
                  textTransform="capitalize"
                >
                  {teamMember.clinic_role || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Designation:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {toProperCase(teamMember.designation) || 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text fontWeight="semibold" color={textColorPrimary}>
                  Created Date:
                </Text>
                <Text color={textColorSecondary} fontSize="md">
                  {teamMember.created_at
                    ? moment(teamMember.created_at).format('MM/DD/YYYY')
                    : 'N/A'}
                </Text>
              </Box>

              <Box>
                <Text
                  fontWeight="semibold"
                  color={textColorPrimary}
                  mb="10px"
                  textTransform="capitalize"
                >
                  Status:
                </Text>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                >
                  <Switch
                    isChecked={currentStatus === 'active'}
                    onChange={handleStatusChange}
                    colorScheme="brand"
                  />
                  <Text color={textColorSecondary} fontSize="md" mt="0px">
                    {currentStatus === 'active' ? 'Enabled' : 'Disabled'}
                  </Text>
                </div>
              </Box>

              <Box mt="30px">
                <Button
                  fontWeight="500"
                  colorScheme="red"
                  onClick={() => setIsModalOpen(true)}
                  size="md"
                >
                  Reset Password
                </Button>
              </Box>
            </SimpleGrid>
          </Card>
          <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="10px"
              mb="4px"
            >
              Dashboard Setting
            </Text>

            <Text color={textColorSecondary} fontSize="md" me="26px" mb="10px">
              Select Dashboards:
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2} mb="20px">
              {dashboards.map((dashboard) => (
                <Checkbox
                  key={dashboard.id}
                  isChecked={selectedDashboards.includes(dashboard.id)}
                  onChange={() => handleDashboardChange(dashboard.id)}
                >
                  <span
                    style={{ fontSize: '.85rem', textTransform: 'capitalize' }}
                  >
                    {dashboard.name}
                  </span>
                </Checkbox>
              ))}
            </SimpleGrid>

            <Button
              colorScheme="blue"
              onClick={updateDashboards}
              isLoading={isSavingDashboard}
              w="fit-content"
            >
              Save Changes
            </Button>
          </Card>
          {/* 🟦 Form Access Permission Section */}
          <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="10px"
              mb="4px"
            >
              {/* Form Access Permission */}
              Support 360 – Form Access
            </Text>

            <Text color={textColorSecondary} fontSize="md" mb="20px">
              {/* Control your own permission to access and submit forms. */}
              Manage your permission to view, access, and submit forms within
              the Support 360 Portal.
            </Text>

            <Flex
              align="center"
              justify="space-between"
              border="1px solid"
              borderColor={borderColor}
              borderRadius="md"
              px="4"
              py="3"
              mb="20px"
            >
              <Text color={textColor} fontSize="md" fontWeight="500">
                {/* Enable Form Access */}
                Enable Support 360 Form Access
              </Text>
              <Switch
                isChecked={isFormAccess}
                onChange={(e) => setIsFormAccess(e.target.checked)}
                colorScheme="blue"
                size="lg"
                isDisabled={isSavingFormAccess}
              />
            </Flex>

            <Button
              colorScheme="blue"
              onClick={handleSaveFormAccess}
              isLoading={isSavingFormAccess}
              w="fit-content"
            >
              Save Changes
            </Button>
          </Card>

          <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="10px"
              mb="4px"
            >
              Role Setting
            </Text>

            <Text color={textColorSecondary} fontSize="md" me="26px" mb="10px">
              Role:
            </Text>
            <Select
              name="clinic_role_id"
              variant="auth"
              fontSize="sm"
              fontWeight="500"
              placeholder="Select role"
              // value={currentRole}
              // onChange={handleRoleChange}
              value={currentRoleId}
              onChange={(e) => {
                const id = e.target.value;
                setCurrentRoleId(id);
                const r = roles.find((x) => String(x.id) === String(id));
                setCurrentRoleName((r?.role_name || '').toLowerCase());
              }}
              textTransform="capitalize"
              mb="20px"
            >
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.role_name}
                </option>
              ))}
            </Select>

            <Button
              colorScheme="blue"
              onClick={updateTeam}
              isLoading={isSaving}
              w="fit-content"
            >
              Save Changes
            </Button>
          </Card>

          {/* Add Phone Number Section */}
          <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="10px"
              mb="4px"
            >
              Add Phone Number
            </Text>

            <Text color={textColorSecondary} fontSize="md" me="26px" mb="10px">
              Update or add a phone number for this user:
            </Text>

            <FormControl mb="20px">
              <Input
                variant="auth"
                fontSize="sm"
                fontWeight="500"
                placeholder="(XXX) XXX-XXXX"
                maxLength={14}
                value={teamMember.phone || ''}
                onChange={(e) => {
                  const formatted = formatPhoneNumber(e.target.value);
                  setTeamMember((prev) => ({ ...prev, phone: formatted }));
                }}
              />
            </FormControl>

            <Button
              colorScheme="blue"
              onClick={handleSavePhone}
              isLoading={isSavingPhone}
              w="fit-content"
            >
              Save Changes
            </Button>
          </Card>

          {/* <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="10px"
              mb="4px"
            >
              Session Setting
            </Text>

            <Text color={textColorSecondary} fontSize="md" mb="16px">
              This affects new tokens on next login / 2FA token generation.
              Already-issued tokens are unchanged.
            </Text>

            <Flex align="center" justify="space-between" mb="18px" gap="12px">
              <Text fontWeight="600">Extended session (30 days)</Text>

              <Switch
                colorScheme="brand"
                isChecked={enable30dTokenExpiry}
                onChange={(e) => setEnable30dTokenExpiry(e.target.checked)}
              />
            </Flex>

            {effectiveTokenExpiryDays && (
              <Text fontSize="sm" color={textColorSecondary} mb="14px">
                Current effective expiry: {effectiveTokenExpiryDays} days
              </Text>
            )}

            <Button
              colorScheme="blue"
              onClick={handleSaveTokenExpiry}
              isLoading={isSavingTokenExpiry}
              w="fit-content"
            >
              Save Changes
            </Button>
          </Card> */}

          <Card {...rest}>
            <Text
              color={textColorPrimary}
              fontWeight="bold"
              fontSize="2xl"
              mt="10px"
              mb="4px"
            >
              QR Authenticator
            </Text>

            <Text color={textColorSecondary} fontSize="md" mb="20px">
              Reset the QR code for this user to reconfigure their Authenticator
              app at next login.
            </Text>

            <Button
              // colorScheme="blue"
              colorScheme="red"
              onClick={handleQrReset}
              size="md"
              w="fit-content"
            >
              Reset QR Authenticator
            </Button>
          </Card>
          {currentRoleName === 'staff' && (
            <Card {...rest}>
              <Flex
                mb="8px"
                justify="space-between"
                align="center"
                direction={{ base: 'column', md: 'row' }}
                gap={{ base: 4, md: 0 }}
              >
                <Text
                  color={textColorPrimary}
                  fontWeight="bold"
                  fontSize="2xl"
                  mt="10px"
                  mb="4px"
                >
                  Assigned Locations
                </Text>

                <Box w={{ base: '100%', md: 'auto' }}>
                  <Button
                    w={{ base: '100%', md: 'fit-content' }}
                    variant="brand"
                    fontWeight="500"
                    onClick={handleAssignClick}
                    mr="8px"
                    size="sm"
                    borderRadius="12px"
                  >
                    Assign Location
                  </Button>
                </Box>
              </Flex>

              <Box overflowX="auto">
                <Table variant="striped" color="gray.500" mb="24px" mt="12px">
                  <Thead position="sticky" top={0} bg="white" zIndex={1}>
                    {staffLocationTable.getHeaderGroups().map((headerGroup) => (
                      <Tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                          <Th
                            key={header.id}
                            pe="10px"
                            borderColor={borderColor}
                          >
                            <Flex justifyContent="space-between" align="center">
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext(),
                              )}
                            </Flex>
                          </Th>
                        ))}
                      </Tr>
                    ))}
                  </Thead>
                </Table>

                {/* Scrollable table body wrapper */}
                <Box maxH="275px" overflowY="auto">
                  <Table variant="striped" color="gray.500">
                    <Tbody>
                      {staffLocationTable.getRowModel().rows.map((row) => (
                        <Tr key={row.id}>
                          {row.getVisibleCells().map((cell) => (
                            <Td
                              key={cell.id}
                              fontSize="14px"
                              borderColor="transparent"
                            >
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext(),
                              )}
                            </Td>
                          ))}
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>

                {!loading && staffLocationRows.length === 0 && (
                  <ErrorMessage source="assigned locations" />
                )}
              </Box>
            </Card>
          )}
          <Card
            {...rest}
            // gridColumn={{ base: '1 / -1', lg: '1 / -1' }}
          >
            {/* Header */}
            <Flex
              justify="space-between"
              align="center"
              mb="10px"
              gap="10px"
              wrap="wrap"
            >
              <Box>
                <Text
                  color={textColorPrimary}
                  fontWeight="bold"
                  fontSize="2xl"
                  mt="10px"
                >
                  Login Logs
                </Text>
                <Text color={textColorSecondary} fontSize="sm">
                  Recent login activity for this user
                </Text>
              </Box>
              <Tooltip label="Refresh logs">
                <IconButton
                  aria-label="Refresh"
                  icon={<RepeatIcon />}
                  onClick={() => fetchLoginLogs(teamMember?.user_id)}
                  isLoading={logsLoading}
                  variant="outline"
                />
              </Tooltip>
            </Flex>

            <Divider mb="12px" />

            {/* Filters */}
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3} mb="14px">
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input
                  placeholder="Search logs..."
                  value={logSearch}
                  onChange={(e) => setLogSearch(e.target.value)}
                />
              </InputGroup>
              <Select
                value={logTag}
                onChange={(e) => setLogTag(e.target.value)}
              >
                {availableTags.map((t) => (
                  <option key={t} value={t}>
                    {toProperCase(t)}
                  </option>
                ))}
              </Select>
              <Select
                value={logStatus}
                onChange={(e) => setLogStatus(e.target.value)}
              >
                {availableStatuses.map((s) => (
                  <option key={String(s)} value={String(s)}>
                    {String(s)}
                  </option>
                ))}
              </Select>
            </SimpleGrid>

            {/* Logs List */}
            <Box
              border="1px solid"
              borderColor={borderColor}
              borderRadius="12px"
              overflow="hidden"
              maxH="350px"
              overflowY="auto"
            >
              {logsLoading ? (
                <VStack spacing={0} divider={<Divider />}>
                  {[...Array(6)].map((_, i) => (
                    <Box key={i} w="100%" p={4}>
                      <Box
                        h="56px"
                        bg={skeletonBg}
                        borderRadius="10px"
                        opacity={0.7}
                      />
                    </Box>
                  ))}
                </VStack>
              ) : filteredLogs.length === 0 ? (
                <Flex
                  direction="column"
                  justify="center"
                  align="center"
                  py={12}
                >
                  <Text color={textColorSecondary} fontSize="md">
                    {logsError ? logsError : 'No login logs found'}
                  </Text>
                </Flex>
              ) : (
                <VStack spacing={0} divider={<Divider />} align="stretch">
                  {filteredLogs.map((l, idx) => {
                    const st = getStatusBadge(l.status_code);

                    return (
                      <Flex
                        key={l.id}
                        px={5}
                        py={3}
                        gap={4}
                        align="center"
                        cursor="pointer"
                        bg={idx % 2 === 0 ? 'transparent' : 'blackAlpha.50'}
                        _hover={{
                          bg: 'blackAlpha.100',
                        }}
                        transition="background 0.15s ease"
                      >
                        {/* Date */}
                        <Box minW="150px">
                          <Text
                            fontSize="sm"
                            color={textColor}
                            fontWeight="600"
                          >
                            {convertToCST(l.created_at)}
                          </Text>
                        </Box>

                        {/* Status */}
                        <Flex align="center" gap={2} minW="110px">
                          <Box
                            w="8px"
                            h="8px"
                            borderRadius="full"
                            bg={`${st.scheme}.400`}
                          />
                          <Badge
                            colorScheme={st.scheme}
                            borderRadius="full"
                            px={3}
                            py={1}
                            fontSize="xs"
                            textAlign="center"
                          >
                            {st.label}
                          </Badge>
                        </Flex>

                        {/* Message */}
                        <Box flex="1" minW={0}>
                          <Tooltip
                            label={l.message || ''}
                            hasArrow
                            placement="top"
                          >
                            <Text
                              fontSize="sm"
                              color={textColor}
                              noOfLines={1}
                              fontWeight="500"
                            >
                              {l.message || '—'}
                            </Text>
                          </Tooltip>
                        </Box>
                      </Flex>
                    );
                  })}
                </VStack>
              )}
            </Box>

            {/* Footer */}
            <Flex
              justify="space-between"
              align="center"
              mt={4}
              flexWrap="wrap"
              gap={3}
            >
              <Text fontSize="sm" color={textColorSecondary}>
                Showing{' '}
                <Text as="span" fontWeight="bold">
                  {filteredLogs.length}
                </Text>{' '}
                of {loginLogs.length} logs
              </Text>
              <Button
                size="sm"
                variant="outline"
                onClick={() => {
                  setLogSearch('');
                  setLogTag('ALL');
                  setLogStatus('ALL');
                }}
              >
                Clear Filters
              </Button>
            </Flex>
          </Card>
        </Grid>

        <AssignLocationModalV2
          isOpen={isAssignOpen}
          onClose={() => setIsAssignOpen(false)}
          fetchAgain={fetchStaffLocations}
          preselectedMemberId={teamMember?.user_id}
          preselectedMemberName={`${teamMember?.first_name || ''} ${
            teamMember?.last_name || ''
          }`.trim()}
        />

        <ResetPasswordModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          update_id={teamMember?.user_id}
        />

        <DeleteModal
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModal}
          onDelete={handleDeleteItem}
          selectedItem={selectedItem?.location_name}
          isLoading={isDeleting}
        />
      </Box>
    </>
  );
}
